import { useState } from "react";
import { Form } from "react-bootstrap";
import EntityManager from "./EntityManager.jsx";
import QuoteTemplatesManager from "./QuoteTemplatesManager.jsx";

// Quote Fee Profiles — the whole quote-fee configuration on ONE tab (Robert
// 2026-09-05): the profile cascade grid (WHO is charged WHAT — quotes.md 8.9)
// and the fee registries (what each line SAYS and its standard rate —
// 8.1/8.3/8.10/8.20). Both existed before; the registries lived on the Quote
// Templates tab as extra radios, which made that tab two things at once.
// Nothing about the data or the endpoints changed — the grid is the generic
// entity editor for quote_fee_profiles, the registries are the templates
// manager in its "fees" mode — and the Orders side mirrors this pair (Order
// Templates / Order Fee Profiles).
//
// Two VIEWS behind a radio, not one long page (Robert, same day): the profile
// grid will grow, and the registries deserve a page of their own to read on.
// Same two-level shape as Quote Templates — the question first, then the
// answers (the FEE radios inside the registries view).
const VIEWS = [
  { key: "profiles", label: "Quote Fee Profiles" },
  { key: "rates", label: "Standard rates and wording" },
];

function QuoteFeeProfilesPanel({ entity, canWrite, includeInactive, initialEditId, onDeepLinkDone }) {
  // A deep link into a profile row lands on the grid, which is also the default.
  const [view, setView] = useState("profiles");
  return (
    <>
      <div className="d-flex flex-wrap align-items-center column-gap-4 row-gap-1 mb-3">
        <span className="text-uppercase fw-semibold small text-muted" style={{ letterSpacing: "0.06em" }}>
          Show
        </span>
        {VIEWS.map((v) => (
          <Form.Check
            key={v.key}
            inline type="radio" id={`qfp-view-${v.key}`} name="qfp-view"
            label={v.label}
            checked={view === v.key}
            onChange={() => setView(v.key)}
            className="me-0"
          />
        ))}
      </div>
      {view === "profiles" ? (
        <EntityManager
          entity={entity}
          includeInactive={includeInactive}
          initialEditId={initialEditId}
          onDeepLinkDone={onDeepLinkDone}
        />
      ) : (
        <QuoteTemplatesManager mode="fees" canWrite={canWrite} />
      )}
    </>
  );
}

export default QuoteFeeProfilesPanel;
